import getConfig from './getConfig';

export async function getParseConfiguration(name) {
  const configurations = await getConfig();
  return await configurations.get(name);
}
